import { ModalBody, Stack } from "@chakra-ui/react";
import { Modal, Json as JsonView, Alert } from "components";

export default function Json({ data = {}, title = "Dados para nerds", ...props }){
    return(
    <Modal title={title} {...props} size="2xl">
        <ModalBody>
            <Stack spacing={8}>
                <Alert title="Apenas para desenvolvedores" children="Estes dados tem o objetivo de facilitar o debug para os desenvolvedores." />
                <JsonView src={data} collapsed={true} style={{ background: 'white', padding: 12, borderRadius: 5 }} />
            </Stack>
        </ModalBody>
    </Modal>
    )
}